import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IkeyCodeEvents, InumberRange } from './ICurrencyFormatter.interface';
import { PaperCurrencyPipe } from './paper-currency.pipe';

@Directive({ selector: '[paperCurrencyFormatter]' })
export class PaperCurrencyFormatterDirective implements OnInit {
  private el: HTMLInputElement;
  @Input('negative_parentheses') negative_parentheses = false;
  @Input('paperCurrencyFormatter') initial_amount = '';
  @Output() amountParsed = new EventEmitter<number>();
  @Input('prefix_currency') prefix_currency = '';
  negativeParenthesesCode = [37, 39, 8, 46];

  constructor(
    private elementRef: ElementRef,
    private currencyPipe: PaperCurrencyPipe
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    // YS: To transform initial value when editing etc
    const parsedValue = this.currencyPipe.parse(this.el.value);
    this.el.value = this.currencyPipe.transformInPlace(
      parsedValue,
      2,
      this.negative_parentheses
    );
  }

  @HostListener('click', ['$event'])
  onFocus(event: { target: { selectionStart: any; selectionEnd: any } }) {
    if (this.negative_parentheses) {
      // YS: Shift the cursor position if it is before or after parenthesis
      let start = event.target.selectionStart;
      let end = event.target.selectionEnd;
      //

      if (start == 0) {
        start = start + 1;
        end = end + 1;
      } else if (start == this.el.value.length) {
        start = start - 1;
        end = end - 1;
      }
      this.el.setSelectionRange(start, end);
    }
  }

  @HostListener('keyup', ['$event.target.value', '$event'])
  onKeyup(value: string, event: { keyCode: number }) {
    let parsedValue = this.currencyPipe.parse(value);

    // YS: Trying to Set the Cursor to the current position
    let start = this.el.selectionStart;
    let end = this.el.selectionEnd;

    let original_length = this.el.value.length;

    // YS: Transforming while typing, now using transformInPlace instead of regular transform
    // that way, we can differentiate clearly the typing and the behavior
    let transformed_value = this.currencyPipe.transformInPlace(parsedValue);
    if (this.negative_parentheses) {
      this.el.value = '(' + transformed_value + ')';
    } else {
      this.el.value = transformed_value;
    }

    let diff_length = this.el.value.length - original_length;

    // YS: To handle numbers and Numpad specifically
    this.handleNumbersAndNumpadInput(event, { start, end }, diff_length);

    // YS: To Shift cursor from before or after parenthesis
    this.handleNegativeParentheses(event, { start, end });

    // YS: Need one more parsing pass, because the transform actually limit to 2 digits behind '.' so 4.238 becomes 4.23
    let numberParsedValue: number = parseFloat(
      this.currencyPipe.parse(this.el.value)
    );

    this.amountParsed.emit(numberParsedValue);
  }

  ngOnChanges() {
    if (
      !isNaN(parseFloat(this.initial_amount)) &&
      isFinite(Number(this.initial_amount))
    ) {
      if (this.negative_parentheses) {
        this.el.value =
          '(' + this.currencyPipe.transformInPlace(this.initial_amount) + ')';
      } else if (this.prefix_currency) {
        this.el.value = `${
          this.prefix_currency
        }. ${this.currencyPipe.transformInPlace(this.initial_amount)}`;
      } else {
        this.el.value = this.currencyPipe.transformInPlace(this.initial_amount);
      }
    }
  }

  handleNumbersAndNumpadInput(
    event: IkeyCodeEvents,
    range: InumberRange,
    diffLength: number
  ) {
    if (
      (48 <= event.keyCode && event.keyCode <= 57) ||
      (96 <= event.keyCode && event.keyCode <= 105) ||
      event.keyCode == 8 ||
      event.keyCode == 46
    ) {
      range.start = Number(range.start) + diffLength;
      range.end = Number(range.end) + diffLength;

      if (range.start < 0) range.start = 0;
      if (range.end < 0) range.end = 0;
      //

      this.el.setSelectionRange(range.start, range.end);
    }
  }

  handleNegativeParentheses(event: IkeyCodeEvents, range: InumberRange) {
    if (
      this.negative_parentheses &&
      this.negativeParenthesesCode.includes(event.keyCode)
    ) {
      if (range.start == 0) {
        range.start = range.start + 1;
        range.end = Number(range.end) + 1;
      } else if (range.start == this.el.value.length) {
        range.start = range.start - 1;
        range.end = Number(range.end) - 1;
      }
      //
      this.el.setSelectionRange(range.start, range.end);
    }
  }
}
